import { axInst } from "../../components/Service/Service";

export const getintendedapp = async (payload) => {
    const res = await axInst.post(
        `${process.env.REACT_APP_API_URL}intended_application`,
        payload
    );
    return res.data.result;
};


export const getrevenuedetaill = async (payload) => {
    const res = await axInst.post(
        `${process.env.REACT_APP_API_URL}spares_revenue_pop_up`,
        payload
    );
    return res.data.result;
};

export const getFinancierAnalysis = async (payload) => {
    const res = await axInst.post(
        `${process.env.REACT_APP_API_URL}financier_analysis`,
        payload
    );
    return res.data.result;
};
